import React, { useEffect } from "react"
import { observer } from "mobx-react-lite"
import { Table, ScrollArea } from "@mantine/core"
import { ScheduleEventStore } from "../../app/store"
import { ResultWrapper } from "../../entities/resultWrapper"
import { type ScheduleEvent } from "../../shared/types/scheduleEvent"

// ----------------------------------------------------------------------


type Props = {
  rowComponent: React.JSXElementConstructor<ScheduleEvent>
}


export const ScheduleTable = observer(function ScheduleTable({ rowComponent }: Props) {
  const { scheduleEvents, load, isLoading, error } = ScheduleEventStore

  const Row = rowComponent

  useEffect(() => {
    void load()
  }, [ load ])

  return (
    <ResultWrapper
      isLoading={isLoading}
      isEmpty={!scheduleEvents.length}
      error={error}
    >
      <ScrollArea sx={{ flex: "auto" }}>
        <Table highlightOnHover sx={{ minWidth: 800 }} verticalSpacing="sm">
          <thead>
          <tr>
            <th>Элемент расписания</th>
            <th>Преподаватель</th>
            <th>Дата проведения</th>
            <th style={{ textAlign: "center" }}>Онлайн</th>
            <th style={{ textAlign: "center" }}>Профессия</th>
            <th style={{ textAlign: "right" }}>Действия</th>
          </tr>
          </thead>
          <tbody>
          {scheduleEvents.map((item) => (
            <Row key={item._id} {...item} />
          ))}
          </tbody>
        </Table>
      </ScrollArea>
    </ResultWrapper>
  )
})
